import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IConfiguration } from '../models/configuration.model';
import { StorageService } from './storage.service';
import { Subject } from 'rxjs';

@Injectable()
export class ConfigurationService {
  serverSettings: IConfiguration;
  private settingsLoadedSource = new Subject();
  settingsLoaded$ = this.settingsLoadedSource.asObservable();
  isReady: boolean = false;

  constructor(private http: HttpClient, private storageService: StorageService) {
    this.load();
   }
   load() {
     const baseURI = `${location.origin}/`;
     let url = `${baseURI}Configurations/Route`;
     this.http.get(url).subscribe((response) => {
         this.serverSettings = response as IConfiguration;
         this.storageService.store('identityUrl', this.serverSettings.identityUrl);
         this.storageService.store('recruitmentUrl', this.serverSettings.recruitmentUrl);
         this.storageService.store('openingUrl', this.serverSettings.openingUrl);
         this.storageService.store('requestUrl', this.serverSettings.requestUrl);
         this.storageService.store('quotetUrl', this.serverSettings.quoteUrl);
         this.storageService.store('payrollUrl', this.serverSettings.payrollUrl);
         this.storageService.store('messageUrl', this.serverSettings.messageUrl);
         this.storageService.store('incidentUrl', this.serverSettings.incidentUrl);
         this.storageService.store('moneyUrl', this.serverSettings.moneyUrl);
         this.isReady = true;
         this.settingsLoadedSource.next();
     });
   }
}
